"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBool = exports.findNeighbors = exports.findChildren = exports.sortNeighbors = exports.sortFields = exports.filterEntitiesToPastAndPresentWP = exports.filterEntitiesToPastAndPresent = exports.sortChildEntities = exports.sortChildrenByTime = exports.structuredCloneL = exports.getChildTimeAndCombine = exports.combineChildTimeAndParent = exports.getChildEntities = exports.getV2ValueWP = exports.getV2Value = exports.isUserPartOfUsersWithTags = exports.recursiveFindValue = exports.parseValueToString = exports.isPastL = exports.turnObjectKeyToArray = void 0;
const date_fns_1 = require("date-fns");
const underscore_1 = __importDefault(require("underscore"));
const compare_1 = require("../date/compare");
const date_1 = require("../date/date");
const field_1 = require("../interfaces/field");
const json_1 = require("./json");
const turnObjectKeyToArray = (obj, key) => {
    obj[key ?? ''] = [obj[key ?? '']];
    return obj;
};
exports.turnObjectKeyToArray = turnObjectKeyToArray;
/**
 * @deprecated Use isDateInPast. PLEASE!
 */
const isPastL = (date) => {
    return (0, compare_1.isDateInPast)(date);
};
exports.isPastL = isPastL;
const parseValueToString = (val) => {
    switch (typeof val) {
        case 'number':
            return val.toString();
        case 'object':
            return JSON.stringify(val);
        default:
            return val;
    }
};
exports.parseValueToString = parseValueToString;
const recursiveFindValue = (valueLocator, data, user) => {
    const valueArray = valueLocator.split('.');
    let value = data;
    for (const item of valueArray) {
        if (value) {
            if (item.startsWith('[') && item.endsWith(']')) {
                const action = item.substring(1, item.length - 1);
                if (action.startsWith('userIn:')) {
                    const usersLocator = action.substring(7);
                    if (underscore_1.default.isArray(value)) {
                        /// Check if includes an or, will then split list based on or.
                        if (usersLocator.includes('||')) {
                            const usersLocatorList = usersLocator.split('||');
                            let tmpValue; /// Set as any as idk what its meant to be...
                            /// Will loop through each list to check. will return first in list found.
                            for (const userLocatorStr of usersLocatorList) {
                                tmpValue = value.find((v) => {
                                    const users = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(userLocatorStr, v, user), []);
                                    if (user)
                                        return (0, exports.isUserPartOfUsersWithTags)(user, users);
                                    return false;
                                });
                                if (tmpValue) {
                                    value = tmpValue;
                                    break; /// Break on first found
                                }
                            }
                        }
                        else {
                            /// Logic for not using ||
                            value = value.find((v) => {
                                const users = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(usersLocator, v, user), []);
                                if (user)
                                    return (0, exports.isUserPartOfUsersWithTags)(user, users);
                                return false;
                            });
                        }
                    }
                }
                if (action.startsWith('userInMultiple:')) {
                    const usersLocator = action.substring(15);
                    if (underscore_1.default.isArray(value)) {
                        value = value.filter((v) => {
                            const users = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(usersLocator, v, user), []);
                            if (user)
                                return (0, exports.isUserPartOfUsersWithTags)(user, users);
                            return false;
                        });
                    }
                }
                if (action.startsWith('all:')) {
                    const usersLocator = action.substring(4);
                    if (underscore_1.default.isArray(value)) {
                        const multiUserList = value.map((v) => {
                            const users = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(usersLocator, v, user), []);
                            return users;
                        });
                        value = underscore_1.default.flatten(multiUserList, 1);
                    }
                }
            }
            else {
                value = value[item];
            }
        }
        else {
            return '';
        }
    }
    return value;
};
exports.recursiveFindValue = recursiveFindValue;
const isUserPartOfUsersWithTags = (wpUser, userWithTags) => {
    if (userWithTags) {
        return userWithTags.some((u) => {
            if (u.type === 'User') {
                return u.option === wpUser.id;
            }
            if (u.type === 'Department') {
                return wpUser.departmentTags.some((t) => {
                    return t === u.option;
                });
            }
            if (u.type === 'Group') {
                return wpUser.groupTags.some((t) => {
                    return t === u.option;
                });
            }
            return false;
        });
    }
    return false;
};
exports.isUserPartOfUsersWithTags = isUserPartOfUsersWithTags;
/**
 * @deprecated The method should not be used
 */
const getV2Value = (valueLocator, data, currUser) => {
    if (!valueLocator)
        return '';
    if (valueLocator.startsWith('${') && valueLocator.endsWith('}')) {
        switch (valueLocator) {
            /* eslint-disable no-template-curly-in-string */
            case '${userId}':
                return currUser;
            default:
                break;
        }
    }
    if (valueLocator.startsWith('TEXT:')) {
        return valueLocator.substring(5);
    }
    else {
        const value = (0, exports.parseValueToString)((0, exports.recursiveFindValue)(valueLocator, data));
        if (value === undefined)
            return '';
        return value;
    }
};
exports.getV2Value = getV2Value;
const getV2ValueWP = (valueLocator, data, currUser) => {
    if (!valueLocator)
        return '';
    if (valueLocator.startsWith('${') && valueLocator.endsWith('}')) {
        switch (valueLocator) {
            /* eslint-disable no-template-curly-in-string */
            case '${userId}':
                return currUser.id;
            default:
                break;
        }
    }
    if (valueLocator.startsWith('BOOL:')) {
        return (0, exports.parseBool)(valueLocator.substring(5));
    }
    if (valueLocator.startsWith('TEXT:')) {
        return valueLocator.substring(5);
    }
    else {
        const value = (0, exports.parseValueToString)((0, exports.recursiveFindValue)(valueLocator, data, currUser));
        if (value === undefined)
            return '';
        return value;
    }
};
exports.getV2ValueWP = getV2ValueWP;
const getChildEntities = (d, childEntity) => {
    const childEntities = [];
    const children = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(childEntity ?? '', d), []);
    if (children) {
        children.forEach((c) => {
            const dCopy = (0, exports.structuredCloneL)(d);
            dCopy[childEntity ?? ''] = c;
            childEntities.push(dCopy);
        });
    }
    return childEntities;
};
exports.getChildEntities = getChildEntities;
/**
 * Will combine the two given times in differnt ways given the joiner.
 */
const combineChildTimeAndParent = (parentTime, childTime, pastCriteriaJoiner) => {
    if (pastCriteriaJoiner) {
        switch (pastCriteriaJoiner) {
            case 'and':
                return parentTime + 'T' + childTime;
            case 'childTimeIfParentEmpty':
                return parentTime === '' ? childTime : parentTime;
            default:
                return parentTime + 'T' + childTime;
        }
    }
    else {
        return parentTime + 'T' + childTime;
    }
};
exports.combineChildTimeAndParent = combineChildTimeAndParent;
/**
 * Will get the wp v2 value for the child and combine with the parent date.
 */
const getChildTimeAndCombine = (childEntity, childEntityPastCriteria, parentDate, pastCriteriaJoiner) => {
    const childTime = (0, exports.getV2ValueWP)(childEntityPastCriteria, childEntity);
    const combTime = (0, exports.combineChildTimeAndParent)(parentDate, childTime, pastCriteriaJoiner);
    return combTime;
};
exports.getChildTimeAndCombine = getChildTimeAndCombine;
/**
 * Work around for js not making a new obj but making a reference to the old obj.
 * NB: Object.assign might work better but not been tested.
 */
const structuredCloneL = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
exports.structuredCloneL = structuredCloneL;
/**
 * Organise the list of children by the childEntityPastCriteria.
 * converts the dates to eventrdates and compares the unix.
 */
const sortChildrenByTime = (childEntities, fullV2, parentDate) => {
    const copyChildren = (0, exports.structuredCloneL)(childEntities);
    copyChildren.sort((a, b) => {
        const combTimeA = new date_1.EventrDate((0, exports.getChildTimeAndCombine)(a, fullV2.childEntityPastCriteria ?? '', parentDate, fullV2.pastCriteriaJoiner));
        const combTimeB = new date_1.EventrDate((0, exports.getChildTimeAndCombine)(b, fullV2.childEntityPastCriteria ?? '', parentDate, fullV2.pastCriteriaJoiner));
        return combTimeA.getUnixMs > combTimeB.getUnixMs ? 1 : -1;
    });
    return copyChildren;
};
exports.sortChildrenByTime = sortChildrenByTime;
/**
 * Void function that will split the child entities between past and present.
 * Will also be sorted in thoes lists.
 * Lists given will be updated via the reference of that list. kinda weird.
 */
const sortChildEntities = (childEntities, fullV2, parentDate, pastEl, presentEl) => {
    childEntities.forEach((childEntity) => {
        const combTime = (0, exports.getChildTimeAndCombine)(childEntity, fullV2.childEntityPastCriteria ?? '', parentDate, fullV2.pastCriteriaJoiner);
        if ((0, compare_1.isDateInPast)(combTime)) {
            const pastElement = pastEl.find((p) => p.entity._id === childEntity._id);
            if (pastElement) {
                pastElement.entity[fullV2.childEntity ?? ''].push(childEntity[fullV2.childEntity ?? '']);
            }
            else {
                const cWithArray = (0, exports.turnObjectKeyToArray)(childEntity, fullV2.childEntity ?? '');
                pastEl.push({ date: combTime, entity: cWithArray });
            }
        }
        else {
            const presElement = presentEl.find((p) => p.entity._id === childEntity._id);
            if (presElement) {
                presElement.entity[fullV2.childEntity ?? ''].push(childEntity[fullV2.childEntity ?? '']);
            }
            else {
                const cWithArray = (0, exports.turnObjectKeyToArray)(childEntity, fullV2.childEntity ?? '');
                presentEl.push({
                    date: combTime,
                    entity: cWithArray,
                });
            }
        }
    });
};
exports.sortChildEntities = sortChildEntities;
/**
 * @deprecated The method should not be used
 */
const filterEntitiesToPastAndPresent = (data, currUser, fullV2) => {
    if (fullV2.pastCriteria) {
        const pastEl = [];
        const presentEl = [];
        data.forEach((e) => {
            const date = (0, exports.getV2Value)(fullV2.pastCriteria, e, currUser);
            if (fullV2.childEntity) {
                const childEntities = (0, exports.getChildEntities)(e, fullV2.childEntity);
                (0, exports.sortChildEntities)(childEntities, fullV2, date, pastEl, presentEl);
            }
            else {
                if ((0, exports.isPastL)(date)) {
                    pastEl.push({ date, entity: e });
                }
                else {
                    presentEl.push({ date, entity: e });
                }
            }
        });
        const sort = (a, b) => {
            return (0, date_fns_1.compareAsc)((0, date_fns_1.parseISO)(a.date), (0, date_fns_1.parseISO)(b.date));
        };
        const sortedPresentEl = presentEl.sort(sort).map((e) => e.entity);
        const sortedPastEl = pastEl.sort(sort).map((e) => e.entity);
        return { present: sortedPresentEl, past: sortedPastEl };
    }
    return { present: data, past: [] };
};
exports.filterEntitiesToPastAndPresent = filterEntitiesToPastAndPresent;
const filterEntitiesToPastAndPresentWP = (data, currUser, fullV2, screenType) => {
    if (fullV2.pastCriteria) {
        const pastEl = [];
        const presentEl = [];
        data.forEach((entitie) => {
            const dateStringComparitor = (0, exports.getV2ValueWP)(fullV2.pastCriteria, entitie, currUser);
            const dateStringComparitorOther = (0, exports.getV2ValueWP)(fullV2.secondaryCard, entitie, currUser);
            const sortByValue = (0, exports.getV2ValueWP)(fullV2.sortBy, entitie, currUser);
            const comparitorToUse = dateStringComparitor !== ''
                ? dateStringComparitor
                : dateStringComparitorOther;
            if (fullV2.childEntity) {
                const childEntities = (0, exports.getChildEntities)(entitie, fullV2.childEntity);
                (0, exports.sortChildEntities)(childEntities, fullV2, comparitorToUse, pastEl, presentEl);
            }
            else {
                if ((0, compare_1.isDateInPast)(comparitorToUse)) {
                    if (fullV2.multiBooking) {
                        const userInBookings = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(fullV2.multiBooking.locator, entitie, currUser), []);
                        userInBookings.forEach((element) => {
                            pastEl.push({
                                date: element[fullV2.multiBooking.secondaryCard],
                                entity: {
                                    ...entitie,
                                    identifier: element[fullV2.multiBooking
                                        .bookingIdentifier],
                                },
                            });
                        });
                        if (userInBookings.length === 0) {
                            pastEl.push({
                                date: comparitorToUse,
                                entity: entitie,
                            });
                        }
                    }
                    else {
                        pastEl.push({
                            date: comparitorToUse,
                            entity: entitie,
                        });
                    }
                    if (comparitorToUse &&
                        !(0, compare_1.isDateInPast)(comparitorToUse) &&
                        screenType === 'upNext') {
                        presentEl.push({
                            date: comparitorToUse,
                            entity: entitie,
                        });
                    }
                }
                else {
                    if (fullV2.multiBooking) {
                        const userInBookings = (0, json_1.tryParseJSON)((0, exports.getV2ValueWP)(fullV2.multiBooking.locator, entitie, currUser), []);
                        userInBookings.forEach((element) => {
                            presentEl.push({
                                date: element[fullV2.multiBooking.secondaryCard],
                                entity: {
                                    ...entitie,
                                    identifier: element[fullV2.multiBooking
                                        .bookingIdentifier],
                                },
                            });
                        });
                        if (userInBookings.length === 0) {
                            presentEl.push({
                                date: comparitorToUse,
                                entity: entitie,
                            });
                        }
                    }
                    else {
                        presentEl.push({
                            date: comparitorToUse,
                            sortDate: sortByValue === '' ? undefined : sortByValue,
                            entity: entitie,
                        });
                    }
                    if (comparitorToUse &&
                        (0, compare_1.isDateInPast)(comparitorToUse) &&
                        screenType === 'upNext') {
                        pastEl.push({
                            date: comparitorToUse,
                            entity: entitie,
                        });
                    }
                }
            }
        });
        function parseDate(dateString) {
            return new date_1.EventrDate(dateString).getUnixMs;
        }
        const sort = (a, b) => {
            return (parseDate(a.sortDate ?? a.date) -
                parseDate(b.sortDate ?? b.date));
        };
        const sortedPresentEl = presentEl.sort(sort).map((e) => e.entity);
        const sortedPastEl = pastEl.sort(sort).map((e) => e.entity);
        return { present: sortedPresentEl, past: sortedPastEl };
    }
    return { present: data, past: [] };
};
exports.filterEntitiesToPastAndPresentWP = filterEntitiesToPastAndPresentWP;
const sortFields = (fields, neighborIt = true) => {
    const sortedFields = [];
    const childFields = fields
        .sort((a, b) => a.position - b.position)
        .filter((f) => {
        if (f.parent === null) {
            sortedFields.push({ field: f, children: [] });
        }
        return f.parent !== null;
    });
    sortedFields.forEach((s) => {
        s.children = (0, exports.findChildren)(s.field, childFields);
    });
    if (neighborIt) {
        return (0, exports.sortNeighbors)(sortedFields);
    }
    return sortedFields;
};
exports.sortFields = sortFields;
const sortNeighbors = (sortedFields) => {
    for (const sortedField of sortedFields) {
        const neighbors = (0, exports.findNeighbors)(sortedField.field, sortedFields);
        if (sortedField.field.field_type === field_1.FieldTypes.group) {
            (0, exports.sortNeighbors)(neighbors);
        }
        sortedField.neighbors = neighbors;
        sortedFields = sortedFields.filter((s) => !neighbors.map((n) => n.field.id).includes(s.field.id));
        sortedField.children = (0, exports.sortNeighbors)(sortedField.children);
    }
    return sortedFields;
};
exports.sortNeighbors = sortNeighbors;
const findChildren = (parent, fields) => {
    const sortedFields = [];
    fields.filter((f) => {
        if (parent.id === f.parent) {
            sortedFields.push({ field: f, children: [] });
            return true;
        }
        return false;
    });
    sortedFields.forEach((s) => {
        s.children = (0, exports.findChildren)(s.field, fields);
    });
    return sortedFields;
};
exports.findChildren = findChildren;
const findNeighbors = (parent, sortedFields) => {
    const neighbors = sortedFields.filter((s) => s.field.position === parent.position && s.field.id !== parent.id);
    return neighbors;
};
exports.findNeighbors = findNeighbors;
const parseBool = (val) => {
    return val === true || val === 'true';
};
exports.parseBool = parseBool;
